export const MembershipTransactionType = {
    TOPUP      : 4,
}

const membershipTransactionTypeDescLangMap = {
    [MembershipTransactionType.TOPUP]    : "topup_point",
}
export const getMembershipTransactionTypeDesc = (membershipTransactionType) => {
    return lang[membershipTransactionTypeDescLangMap[membershipTransactionType]] || ""
}